/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * SVM API
 * SVM API documentation
 * OpenAPI spec version: 1.0
 */

export type DroneStatusUpdateRequestStatus =
    (typeof DroneStatusUpdateRequestStatus)[keyof typeof DroneStatusUpdateRequestStatus];

export const DroneStatusUpdateRequestStatus = {
    DISABLED: 'DISABLED',
    ENABLED: 'ENABLED',
    RELEASED: 'RELEASED'
} as const;
